module.exports = __webpack_public_path__ + "static/media/MISION.19849783.png";